<div class='wrapper'>
    <div class="panel-title">
        Referral Activity Current Month
    </div>
    <div class='donut-chart' #containerPieChart></div>
    <div *ngIf='labels' class='legend col-12'>
        <div *ngFor='let label of labels; let i = index' class='item col-sm-6 col-xs-12'>
            <div class='circle' [ngStyle]='{"background": colourSlices[i]}'></div>
            <div class='legend-name'>{{label}}</div>
        </div>
        <div class='item col-sm-6 col-xs-12'>
            <div class='circle' [ngStyle]='{"background-color": mostRecentActivityColor}'></div>
            <div class='legend-name'>{{mostRecentActivityLabel}}</div>
        </div>
    </div>
    <div class='tooltip drilldownData'>
        <div *ngIf='selectedSlice'>
            <span class='tooltip-label'>{{selectedSlice.label}}: {{selectedSlice.value}}</span>
            <span class="tooltip-val"></span>
        </div>
    </div>
</div>